<template>
  <div class="topmain">
      <div><van-nav-bar title="MCDEX时讯"></van-nav-bar></div>
      <div class="filter">
        <!-- <div style="width:0.65rem;float:left;">
          <van-dropdown-menu>
            <van-dropdown-item v-model="value" :options="option" />
          </van-dropdown-menu>
        </div> -->
        <van-search v-model="serachvalue" show-action shape="round" @search="onSearch">
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
      </div>
    <!-- 加载数据 -->
    <div class="contentscoll">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onload">
        <van-cell v-for="(item,index) in list" :key="index"  @click="showPopup(item)">
          <div v-html="replaceKeyToColor(serachvalue,item.Title)"></div>
         <!-- 使用 right-icon 插槽来自定义右侧图标 -->
        <template #right-icon>
          <van-icon
            name="search"
            style="line-height: inherit;"
          />
        </template>
      </van-cell>
      </van-list>
    </div>
   <!-- <div v-else class="contentscoll">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onload">
        <van-cell is-link  v-for="(item,index) in list" :key="index"  @click="showPopup(item)">
          <div v-html="replaceKeyToColor(serachvalue,item.Title)+'    '+item.Issue_date"></div>
          <div class="qwjs">[全文检索]<span v-html="replaceKeyToColor(serachvalue,item.Contents.substring(3,35))"></span></div>        
      </van-cell>
      </van-list>
   </div> -->
      <!-- 明细 -->
      <van-popup v-model="show" position="right" :style="{ height: '100%',width:'100%' ,overflow: 'hidden'}" class="topmain">        
        <van-nav-bar :title="title"  left-text="返回" left-arrow @click-left="onClickLeft1"></van-nav-bar>
        <!-- <div class="titlse">{{title}}</div> -->
        <deptcontent v-if="show" :contentdetail="content"></deptcontent>
      </van-popup> 

      <!-- 底部 -->
      <div style="height:0.5rem;width:100%;"></div>
        <van-tabbar active-color="#1989fa"  inactive-color="#000" route>
            <!-- <van-tabbar-item replace to="/home" icon="wap-home-o">首页</van-tabbar-item> -->
            <van-tabbar-item replace to="/" icon="apps-o">科室分类</van-tabbar-item>
            <van-tabbar-item replace to="/PublicTime" icon="clock-o">发布时间</van-tabbar-item>
            <van-tabbar-item replace to="/Search" icon="search">搜索</van-tabbar-item>    
        </van-tabbar>
  </div>
</template>

<script>
import { Toast } from 'vant';
import deptcontent from  './DeptContent'
export default {
  name: 'Search', 
  components:{
      deptcontent
  }, 
  data () {
    return {
      value: 1,
      option:[  { text: '标题', value: 1 },
              { text: '全文检索', value: 2 }],
      serachvalue:'',
      list: [],
      loading: false,
      finished: false,
      PageIndex:1,
      PageSize:20,
      show:false,
      content:[],
      title:''
    }
  },
  created(){
    //  this.onSearch('');
  },
  methods:{
     
    onload(){   
      // if(this.val=='搜索'){
      //     return;
      //   }    
    this.$axios
      .get(window.apiUrl+"/pc/mcdex/GetSearchDeptTitle", {
        params: {
          SearchId:this.value,
          Contents:this.serachvalue,
          PageIndex:this.PageIndex,
          PageSize:this.PageSize
        }
      })
      .then(res => {
        if (res.data.Errs.length == 0) {
            this.loading = false;

            if(this.PageIndex>1){
                this.list = [...this.list,...res.data.Result.Data];       
            }else{
                this.list = res.data.Result.Data;       
            }
                 
            const len = this.list.length;
            if(len < res.data.Result.Total){
              this.PageIndex= parseInt(len / this.PageSize)+1;              
            }else{
              this.finished = true;
            }
        }
      });
    },
    onClickLeft1(){
      this.show = false;
    },
    onSearch(val) { 
      this.list=[]; 
      this.PageIndex=1;  
      this.finished = false;
      Toast.loading({
      forbidClick: true, // 禁用背景点击
      loadingType: 'spinner',
      message: '加载中'
    }); 
    this.$axios
      .get(window.apiUrl+"/pc/mcdex/GetSearchDeptTitle", {
        params: {
          SearchId:1,
          Contents:this.serachvalue,
          PageIndex:this.PageIndex,
          PageSize:this.PageSize
        }
      })
      .then(res => {
        Toast.clear();
        if (res.data.Errs.length == 0) {
          this.list=res.data.Result.Data;
        }
      });
    },
    showPopup(item){
      this.title=item.Title
      this.$axios
        .get(window.apiUrl+"/pc/mcdex/GetallDeptContent", {
          params: {
            Mnid:item.Mnid,
          }  

        })
        .then(res => {
          if (res.data.Errs.length == 0) {
            this.content=res.data.Result;
            this.content=[...this.content,item]
            // console.log(this.content)
            this.show = true;
          }
        });
  },
    /**
     * 匹配字符串中的关键字符Key,并修改关键字的背景颜色为color 
     * @param {*} key 关键字 必填
     * @param {*} strs  字符串  必填
     * @param {*} color 默认#f00
     */   
    replaceKeyToColor(key,strs,color){
      const initKey = key;
      const col = color || '#F05F21';
      // 处理关键字Key中的特殊字符，将特殊字符进行转义，在其前面加\
      key = key.replace(/[\$\(\)\*\+\.\[\?\^\{\|\\]/gi,function($0){
        return "\\"+$0
      })
      const reg = new RegExp(key,"g");
      const rstr =`<span style='background:${col}'>${initKey}</span>`
      const newStr = strs.replace(reg,rstr); // strs.split(key).join(rstr); //
      return newStr;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.filter{
  overflow: hidden;
  border-bottom: 0.01rem solid #eee;
  height: 0.4rem;
  line-height: 0.4rem;
}
.van-dropdown-menu{
  height: 0.4rem;
}
.van-search{
  height: 0.4rem;
  line-height: 0.4rem;
}
.filter>>>.van-ellipsis{
  font-size: 0.12rem;
}
.qwjs{
    font-size: 0.12rem;
    color: rgb(102, 102, 102);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 3.3rem;
}
.titlse{
  font-size: 0.18rem;
  border-bottom: 0.05rem solid #F2EEEE;
  padding: 0.1rem;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue